import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../shared/routing/RouterUtils';

export default class TaskSendEmailRequest extends GenericRequest {

    constructor(taskId, taskStateId) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.TASK_SEND_EMAIL, { id: taskId }));

    }

    overrideRequest() {
        return {};
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/ws/TaskSendEmailRequest.js